/**
 * TermsSentence - the sign-in screen's "by logging in you agree to the terms of
 * service and privacy policy", with those two phrases linked to the real pages.
 * Any other wording is shown unchanged.
 */

import { Fragment } from 'react'

const LINKS: [RegExp, string][] = [
  [/terms of service|terms & conditions|terms and conditions/i, '/terms'],
  [/privacy policy/i, '/privacy'],
]

export function TermsSentence({ text }: { text: string }) {
  const parts: (string | { label: string; href: string })[] = [text]
  for (const [re, href] of LINKS) {
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i]
      if (typeof p !== 'string') continue
      const m = p.match(re)
      if (!m || m.index === undefined) continue
      parts.splice(i, 1, p.slice(0, m.index), { label: m[0], href }, p.slice(m.index + m[0].length))
      break
    }
  }
  return (
    <>
      {parts.map((p, i) => typeof p === 'string'
        ? <Fragment key={i}>{p}</Fragment>
        : <a key={i} href={p.href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:opacity-80">{p.label}</a>)}
    </>
  )
}
